// extracted by mini-css-extract-plugin
export default {"field":"PhoneInput_field__U+pm9","label":"PhoneInput_label__Ni5hi","required":"PhoneInput_required__wcfQB","phoneInput":"PhoneInput_phoneInput__Vym9K"};